import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { StyleSheetManager } from 'styled-components';
import App from './App';
import { styledComponentsShouldForwardProp } from './helpers/styleHelpers';
import createStore from './store';

const state = window.__PRELOADED_STATE__;
delete window.__PRELOADED_STATE__;

const store = createStore(state);

if (import.meta.env.DEV) {
  // Expose redux store for debugging in dev environment
  window.__STORE__ = store;
}

hydrateRoot(
  document.getElementById('root'),
  <StrictMode>
    {/* As of v6 we need to manually filter out style-only props via isPropValid */}
    <StyleSheetManager shouldForwardProp={styledComponentsShouldForwardProp}>
      <HelmetProvider>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </HelmetProvider>
    </StyleSheetManager>
  </StrictMode>,
);
